import React, { useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './LeftColumn.css';

const LeftColumn = ({ courses }) => {
const coursesTestData = ['Русский язык',
    'Литература',
    'Математика',
    'Геометрия',
    'Биология',
    'Химия',
    'География',
    'Физика',
    'Черчение',
    'Изо',
    'Музыка',
    'Информатика',
    'История',
    'Обществознание',
    'Английский язык',
    'Экология']

// console.log(courses)

    return (
      courses &&  
            <div className='leftColumn__container'>
                <div className='leftColumn__title'>Мои предметы</div>
             {courses.map((course, index) => (
              <Link key={index} to={`/course/${course.id}`}><div >{course.title}</div></Link> 
             ))}
            </div>


    )
}
export default LeftColumn
